import { h } from "vue";

export default {
  name: "TermsContent",
  setup() {
    return () =>
      h(
        "div",
        {
          class: "terms-content mt-5 p-4",
          style: {
            background: "#f9f9f9",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
          },
        },
        [
          h("a", { id: "terms-anchor" }),
          h(
            "h2",
            { style: "color:#B3A369; font-size:1.25rem; font-weight:700;" },
            "🚀 Terms & Conditions (Draft v0.1)"
          ),
          h(
            "p",
            {
              class: "effective-date",
              style: "color:#B3A369; font-weight:600;",
            },
            "Effective Date: 01/06/2025"
          ),
          h("p", [
            "Welcome to ",
            h("span", { style: "color:#B3A369;font-weight:600;" }, "RUOK"),
            "! By using our website, tools, and services, you agree to these Terms & Conditions. We are committed to ",
            h(
              "span",
              { style: "color:#003057;font-weight:600;" },
              "transparency"
            ),
            ", ",
            h(
              "span",
              { style: "color:#003057;font-weight:600;" },
              "data privacy"
            ),
            ", and empowering you to understand and control your data.",
          ]),
          h(
            "h3",
            { style: "color:#B3A369; font-size:1.1rem; font-weight:700;" },
            "1️⃣ User Data Sharing Levels"
          ),
          h("p", "You choose your data sharing level:"),
          h("div", { class: "table-responsive" }, [
            h(
              "table",
              {
                class: "gt-table",
                style:
                  "width:100%;border-collapse:collapse;background:#fff;border-radius:8px;overflow:hidden;",
              },
              [
                h("thead", [
                  h("tr", [
                    h(
                      "th",
                      {
                        style:
                          "background:#003057;color:#fff;font-weight:700;padding:8px;",
                      },
                      "Class"
                    ),
                    h(
                      "th",
                      {
                        style:
                          "background:#003057;color:#fff;font-weight:700;padding:8px;",
                      },
                      "Who Can See Your Data?"
                    ),
                    h(
                      "th",
                      {
                        style:
                          "background:#003057;color:#fff;font-weight:700;padding:8px;",
                      },
                      "What is Shared?"
                    ),
                  ]),
                ]),
                h("tbody", [
                  h("tr", [
                    h("td", [
                      h(
                        "span",
                        { style: "color:#B3A369;font-weight:600;" },
                        "Public"
                      ),
                    ]),
                    h("td", "Anyone (publicly viewable)"),
                    h(
                      "td",
                      "Exact location, full sensor data (CO₂, temp, humidity, pressure)"
                    ),
                  ]),
                  h("tr", [
                    h("td", [
                      h(
                        "span",
                        { style: "color:#B3A369;font-weight:600;" },
                        "Semi-Private"
                      ),
                    ]),
                    h("td", "Limited (e.g., zip code only)"),
                    h(
                      "td",
                      "General location (zip code), selected sensor data"
                    ),
                  ]),
                  h("tr", [
                    h("td", [
                      h(
                        "span",
                        { style: "color:#B3A369;font-weight:600;" },
                        "Private"
                      ),
                    ]),
                    h("td", "Only you + platform developers (Super Admins)"),
                    h(
                      "td",
                      "Your data is private. Only developers can access for system integrity and support purposes."
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
          h("p", [
            h("strong", "Your Choice, Your Control."),
            " You can change your sharing level at any time in your account settings.",
          ]),
          h(
            "h3",
            { style: "color:#B3A369; font-size:1.1rem; font-weight:700;" },
            "2️⃣ Developer (Super Account) Access"
          ),
          h("ul", [
            h(
              "li",
              'Our team ("Super Admins") can access all raw data for debugging, maintenance, and research purposes.'
            ),
            h("li", [
              h("strong", "We will never"),
              " sell, share, or disclose your personal data to third parties without your explicit consent.",
            ]),
            h(
              "li",
              "Developer access is strictly controlled, logged, and audited to ensure transparency."
            ),
          ]),
          h(
            "h3",
            { style: "color:#B3A369; font-size:1.1rem; font-weight:700;" },
            "3️⃣ Data Collected by Our IoT Devices"
          ),
          h("p", "Our IoT platform collects environmental data including:"),
          h("ul", [
            h("li", "CO₂ levels"),
            h("li", "Humidity"),
            h("li", "Temperature"),
            h("li", "Pressure"),
            h("li", "Location data (if you opt in)"),
          ]),
          h("p", [
            "You decide what you want to share based on your data class (",
            h("span", { style: "color:#B3A369;font-weight:600;" }, "Public"),
            ", ",
            h(
              "span",
              { style: "color:#B3A369;font-weight:600;" },
              "Semi-Private"
            ),
            ", ",
            h("span", { style: "color:#B3A369;font-weight:600;" }, "Private"),
            ").",
          ]),
          h(
            "h3",
            { style: "color:#B3A369; font-size:1.1rem; font-weight:700;" },
            "4️⃣ User Registration & Verification"
          ),
          h("p", "You will provide registration details such as:"),
          h("ul", [
            h("li", "Email address (required)"),
            h("li", "Username (required)"),
            h(
              "li",
              "Location (optional, based on your data sharing preferences)"
            ),
            h(
              "li",
              "[Verification process to be confirmed: e.g., email confirmation, two-factor authentication.]"
            ),
          ]),
          h(
            "h3",
            { style: "color:#B3A369; font-size:1.1rem; font-weight:700;" },
            "5️⃣ Privacy Commitment"
          ),
          h("p", [
            h("strong", "Your data belongs to you."),
            " We will never sell, disclose, or share your information with third parties without your explicit consent.",
          ]),
          h(
            "h3",
            { style: "color:#B3A369; font-size:1.1rem; font-weight:700;" },
            "6️⃣ Legal Compliance & Location"
          ),
          h(
            "p",
            "Our platform operates in the United States. While we aim to follow best practices in data protection (e.g., transparency, user control), specific compliance frameworks (e.g., GDPR, CCPA) are not yet implemented unless explicitly stated."
          ),
          h(
            "h3",
            { style: "color:#B3A369; font-size:1.1rem; font-weight:700;" },
            "7️⃣ Updates to Terms"
          ),
          h(
            "p",
            "We may update these Terms periodically. Changes will be posted here with an updated effective date."
          ),
          h(
            "h3",
            { style: "color:#B3A369; font-size:1.1rem; font-weight:700;" },
            "8️⃣ Contact Us"
          ),
          h("p", [
            "For questions or concerns, reach out to us at:",
            h("br"),
            h(
              "span",
              { style: "color:#B3A369;font-weight:600;" },
              "📧 info@asdl.gatech.edu"
            ),
          ]),
        ]
      );
  },
};
